import { render, staticRenderFns } from "./Win.vue?vue&type=template&id=670d70b1"
import script from "./Win.vue?vue&type=script&lang=js"
export * from "./Win.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports